export const frequencies = [50, 100, 250, 500, 1000, 2000, 5000, 10000];
export const [frequencyMin, frequencyMax] = [frequencies[0], frequencies[frequencies.length - 1]];
export const gains1 = [12, 24];
export const gains2 = [-24, -12, 12, 24];
export const gains3 = [-12, -6, 0, 6, 12];

export const frequencyMarks = [
  {
    value: exponentialToLinear(50, [frequencyMin, frequencyMax]),
    scaledValue: 50,
    label: "50",
  },
  {
    value: exponentialToLinear(100, [frequencyMin, frequencyMax]),
    scaledValue: 100,
    label: "100",
  },
  {
    value: exponentialToLinear(250, [frequencyMin, frequencyMax]),
    scaledValue: 250,
    label: "250",
  },
  {
    value: exponentialToLinear(500, [frequencyMin, frequencyMax]),
    scaledValue: 500,
    label: "500",
  },
  {
    value: exponentialToLinear(1000, [frequencyMin, frequencyMax]),
    scaledValue: 1000,
    label: "1k",
  },
  {
    value: exponentialToLinear(2000, [frequencyMin, frequencyMax]),
    scaledValue: 2000,
    label: "2k",
  },
  {
    value: exponentialToLinear(5000, [frequencyMin, frequencyMax]),
    scaledValue: 5000,
    label: "5k",
  },
  {
    value: exponentialToLinear(10000, [frequencyMin, frequencyMax]),
    scaledValue: 10000,
    label: "10k",
  },
];
export const boostCutMarks = [
  {
    value: -24,
    scaledValue: -24,
    label: "-24",
  },
  {
    value: -12,
    scaledValue: -12,
    label: "-12",
  },
  {
    value: 0,
    scaledValue: 0,
    label: "0",
  },
  {
    value: 12,
    scaledValue: 12,
    label: "12",
  },
  {
    value: 24,
    scaledValue: 24,
    label: "24",
  },
];

export const boostMarks = [
  {
    value: 0,
    scaledValue: 0,
    label: "0",
  },
  {
    value: 12,
    scaledValue: 12,
    label: "12",
  },
  {
    value: 24,
    scaledValue: 24,
    label: "24",
  },
];

export const cutMarks = [
  {
    value: -24,
    scaledValue: -24,
    label: "-24",
  },
  {
    value: -12,
    scaledValue: -12,
    label: "-12",
  },
  {
    value: 0,
    scaledValue: 0,
    label: "0",
  },
];

export const linearToExponentialScale = (sliderValue: number) => {
  return linearToExponential(sliderValue, [frequencyMin, frequencyMax]);
};
export const exponentialToLinearScale = (sliderValue: number) => {
  return exponentialToLinear(sliderValue, [frequencyMin, frequencyMax]);
};

export function linearToExponential(value: number, range: [number, number]) {
  let scaledMax = 10;
  let scaledValue = scaleFloat(value, range[0], range[1], 0, scaledMax);
  let easeValue = 2 ** scaledValue;
  let maxValue = 2 ** scaledMax;
  let newValue = scaleFloat(easeValue, 1, maxValue, range[0], range[1]);

  return Math.round(newValue / 10) * 10;
}
export function linearToExponentialFloat(value: number, range: [number, number]) {
  let scaledMax = 10;
  let scaledValue = scaleFloat(value, range[0], range[1], 0, scaledMax);
  let easeValue = 2 ** scaledValue;
  let maxValue = 2 ** scaledMax;
  let newValue = scaleFloat(easeValue, 1, maxValue, range[0], range[1]);

  return newValue;
}

export function exponentialToLinearFloat(value: number, range: [number, number]) {
  let scaledMax = 10;
  let maxValue = 2 ** scaledMax;
  let scaledValue = scaleFloat(value, range[0], range[1], 1, maxValue);
  let easeValue = getBaseLog(2, scaledValue);
  let newValue = scaleFloat(easeValue, 0, scaledMax, range[0], range[1]);
  return newValue;
  // return Math.round(newValue / 10) * 10;
}
export function exponentialToLinear(value: number, range: [number, number]) {
  let scaledMax = 10;
  let maxValue = 2 ** scaledMax;
  let scaledValue = scaleFloat(value, range[0], range[1], 1, maxValue);
  let easeValue = getBaseLog(2, scaledValue);
  let newValue = Math.round(scaleFloat(easeValue, 0, scaledMax, range[0], range[1]));
  return Math.round(newValue);
  // return Math.round(newValue / 10) * 10;
}

function scaleFloat(input: number, inMin: number, inMax: number, outMin: number, outMax: number) {
  var percent = (input - inMin) / (inMax - inMin);
  var output = percent * (outMax - outMin) + outMin;
  return output;
}

export function getBaseLog(x: number, y: number) {
  return Math.log(y) / Math.log(x);
}
